import { Button } from 'shared/ui'
import { LINK_CUSTOM_FIELDS_GUIDE } from 'shared/constants/links'
import styles from './styles.module.scss'

export const CustomFieldsHelpGuideButton = () => (
  <Button
    className={styles.helpButton}
    tag='a'
    href={LINK_CUSTOM_FIELDS_GUIDE}
    text='Help guide'
    target='_blank'
    rel='noreferrer'
    size='medium'
    contained='secondary'
    iconProps={{ icon: 'info' }}
  />
)
